// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"34ec70f1","453":"3f54d552"}[chunkId] + ".chunk.js";
};